module.exports = window["nab"]["commands"];